import { urlAbsoluteToRelative3catinfo } from '@portal-internet/core';
import Boto from 'components/3catinfo/Boto';
import styles from './tagsseo.module.scss';

const TagsSeo = (props) => {
    const { items, altIcona = true } = props;
    return items ? (
        <div className={styles.tags} data-testid='item-noti-tags'>
            <ul className={styles.rowWrap}>
                {items.map((tag, index) => (
                    <li key={`tag-navigation-${index}`}>
                        <Boto
                            route={{
                                href: urlAbsoluteToRelative3catinfo(tag.url)
                            }}
                            estil='lined'
                            tema='secondary'
                            text={tag.text}
                            altIcona={altIcona ? tag.text : ''}
                            icona='fletxa_simple_dreta'
                            iconaInline={true}
                        />
                    </li>
                ))}
            </ul>
        </div>
    ) : (
        <></>
    );
};

export default TagsSeo;
